import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/id-card': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h480zM528 432v-288h-480v288h32.8c-1-4.5-0.8 3.6-0.8-22.4 0-31.8 30.1-57.6 67.2-57.6 11.4 0 17.9 8 44.8 8 26.1 0 34-8 44.8-8 37.1 0 67.2 25.8 67.2 57.6 0 26 0.1 17.9-0.8 22.4h224.8zM360 352c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-112zM360 288c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-112zM360 224c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-112zM192 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/id-card.js
// module id = 1778
// module chunks = 0